import { render, staticRenderFns } from "./focuseprak.vue?vue&type=template&id=0a330613&"
import script from "./focuseprak.vue?vue&type=script&lang=js&"
export * from "./focuseprak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports